import type { IMockRegistrationProps } from "./registration";

export interface EnableMocksOptions {
  /** When false, MSW is not started. Defaults to true. */
  enabled?: boolean;
  baseUrl: IMockRegistrationProps["baseUrl"];
  serviceWorkerUrl?: string;
}

export async function enableMocks(options: EnableMocksOptions) {
  if (options.enabled === false) return;

  const { worker } = await import("./browser");

  await worker({ baseUrl: options.baseUrl }).start({
    onUnhandledRequest: "bypass",
    serviceWorker: { url: options.serviceWorkerUrl ?? "/mockServiceWorker.js" },
  });
}
